export default __webpack_public_path__ + "static/media/lab-bg-crop.1641a043.png";